function SuperAdminPrompts() {
  return <main className="flex flex-col w-full h-full">Propmts</main>;
}

export default SuperAdminPrompts;
